function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1664",
  "data-name": "Group 1664",
  transform: "translate(-329.289 -21.801)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M482,234.841l-116.5-67.262c-3.094-1.787-6.906-1.787-10,0c-3.094,1.786-5,5.088-5,8.66v57.28H10c-5.523,0-10,4.478-10,10 c0,5.522,4.477,10,10,10h340.5v57.242c0,3.571,1.906,6.874,5,8.66c1.547,0.893,3.272,1.34,5,1.34c1.727,0,3.453-0.446,5-1.34 L482,252.16c3.094-1.786,5-5.088,5-8.66C487,239.929,485.094,236.627,482,234.841z M370.5,293.441v-99.882L457,243.5L370.5,293.441 z"
}));

function SvgBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "17px",
    height: "17px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 487 487",
      color: "white"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.c5c7d3eb.svg";
export { ForwardRef as ReactComponent };